var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"o-the-header"},[(_vm.$store.getters.getIsClientData === false)?_c('MoleculeTheHeaderDataRequire'):_vm._e(),_c('div',{class:['o-the-header-navigation', _vm.academyDataColor
      ? 'o-the-header-navigation-academycolor'
      : 'o-the-header-navigation-multicolor']},[_c('MoleculeTheHeaderLogo',{attrs:{"is-loading":_vm.isLoading}}),_c('MoleculeTheHeaderNavigation',{attrs:{"is-loading":_vm.isLoading}}),_c('MoleculeTheHeaderSubMenu')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }